import { app } from "./App";
import { IFormData } from "./IFormData";
import { Popup } from "./Popup";

/** defined in _LayoutFlex.cshtml and filled by Modal TagHelper */
declare let msoPopupForms: Array<IFormData>;
declare let popups: Array<Popup>;

export class PopupForm {
    public static activePopup: Popup;

    /**
     * Open a new popup.
     * @param name Name of the popup, must be created with Modal TagHelper
     * @param params Addional parameters for the url, e.g. 'id=1'
     */
    public static show(name: string, params: string): Popup {
        console.log("show popupFrame");


        let data = PopupForm.findFormData(name);
        if (data != null) {
            let form = new Popup(data);
            popups.push(form);
            form.create(params);
            return form;
        }
        else {
            app.addError("Mso.PopupForm.show: form '" + name + "'was not found");
            return null;
        }
    }

    public static show2(data: IFormData, params: string): Popup {

        console.log("show2 PopupFrame");

        let form = new Popup(data);
        popups.push(form);
        form.create(params);
        return form;
    }

    /**
     * Called in _LayoutFlex.cshtml for popup.
     * @param name Name of the popup.
     */
    public static initIFrame(name: string) {
        // get last popup from parent window
        let parentPopups: Array<Popup> = window.parent["popups"];
        if (parentPopups) {
            PopupForm.activePopup = parentPopups[parentPopups.length - 1];
            if (PopupForm.activePopup.data.name != name) {
                app.addError("Mso.PopupForm.initIFrame: wrong popup name (" + PopupForm.activePopup.data.name + "/" + name + ")");
            }
            else {
                PopupForm.activePopup.initIFrame();
            }
        }
    }

    /**
     *  Get IFormData to given name.
     * @param name Name of the form.
     */
    public static findFormData(name: string) {
        for (let data of msoPopupForms) {
            if (data.name == name) {
                return data;
            }
        }
        return null;
    }
}